import binaryToArrayBuffer from './binaryToArrayBuffer';
import arrayBufferToFile from './arrayBufferToFile';

// ----------------------------------------------------------------------------

function binaryToFile(binary: string, config: Record<string, any> = {}): File {
    // Binary To ArrayBuffer
    const arrayBuffer = binaryToArrayBuffer(binary);

    // ArrayBuffer To File
    const file = arrayBufferToFile(arrayBuffer, config);

    // Return
    return file;
}

// ----------------------------------------------------------------------------

export default binaryToFile;
